import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    sendMail (name, email, body, signing) {
      const request = {
        n: name,
        em: email,
        b: body,
        s: signing
      }
      return api.post('/contact', request)
    }
  }
} else {
  module = {
    _try: 0,

    sendMail (name, email, body, signing) {
      this._try++
      const result = (this._try > 1) ? {} : { err: 'error' }
      return delay(1000)({ data: result })
    }
  }
}

export default module
